import { DatePickerView } from '@mui/lab/DatePicker/shared';
import { DateTime } from 'luxon';
import {
  ChoiceDateBoolean,
  defaultChoicePickerState,
  etaChoice,
  ETA_VIEW,
  FormatoData,
} from './constants';

export const transformToChoiceDate = (
  withoutDay?: string,
  withoutDayMonth?: string
): Array<DatePickerView> => {
  const withoutDayBoolean = withoutDay === ChoiceDateBoolean.active;

  const withoutDayMonthBoolean = withoutDayMonth === ChoiceDateBoolean.active;

  if (withoutDayBoolean) {
    return ['month', 'year'];
  }

  if (withoutDayMonthBoolean) {
    return ['year'];
  }

  return defaultChoicePickerState;
};

// Converte il formato data numerico (es. idFormatodata della risposta) nelle "views"
// che selezionano il radio corrispondente nel componente ChooseDate.
export const formatoDataToChoice = (idFormatodata?: string | number): Array<DatePickerView> => {
  switch (idFormatodata?.toString()) {
    case FormatoData.SenzaGiorno.toString():
      return ['month', 'year'];
    case FormatoData.SenzaGiornoMese.toString():
      return ['year'];
    case FormatoData.Eta.toString():
      return etaChoice;
    default:
      return defaultChoicePickerState;
  }
};

// Converte la selezione del radio (views) nel formato data numerico da salvare/inviare.
export const choiceToFormatoData = (choice?: Array<DatePickerView>): FormatoData => {
  if (choice?.includes(ETA_VIEW)) {
    return FormatoData.Eta;
  }

  const hasDay = choice?.includes('day');
  const hasMonth = choice?.includes('month');
  const hasYear = choice?.includes('year');

  if (!hasDay && hasMonth && hasYear) {
    return FormatoData.SenzaGiorno;
  }

  if (!hasDay && !hasMonth && hasYear) {
    return FormatoData.SenzaGiornoMese;
  }

  return FormatoData.Completa;
};

// Etichetta della data per la tabella, in base al formato scelto:
// completa → gg/MM/aaaa, mese+anno → "marzo 2022", solo anno → "2022", età → "età 21".
export const formatChoiceDateLabel = (
  date: DateTime | null | undefined,
  choice: Array<DatePickerView> = defaultChoicePickerState,
  age?: string
): string => {
  if (choice.includes(ETA_VIEW)) {
    return age ? `età ${age}` : '';
  }

  if (!date) {
    return '';
  }

  const hasDay = choice.includes('day');
  const hasMonth = choice.includes('month');
  const hasYear = choice.includes('year');

  if (!hasDay && hasMonth && hasYear) {
    return date.setLocale('it').toFormat('MMMM yyyy');
  }

  if (!hasDay && !hasMonth && hasYear) {
    return date.toFormat('yyyy');
  }

  return date.toFormat('dd/MM/yyyy');
};
